import type { CountryData } from "@/types/country";
import type { Country } from "@/types/domain";


export const countriesData: Record<string, CountryData> = {
  AF: {
    name: "Afghanistan",
    code: "AF",
    currency: "AFN",
    flag: "🇦🇫",
    dialCode: "+93",
    placeholder: { from: "Kabul", to: "Kandahar" },
  },
  AX: {
    name: "Åland Islands",
    code: "AX",
    currency: "EUR",
    flag: "🇦🇽",
    dialCode: "+358",
    placeholder: { from: "Mariehamn", to: "Jomala" },
  },
  AL: {
    name: "Albania",
    code: "AL",
    currency: "ALL",
    flag: "🇦🇱",
    dialCode: "+355",
    placeholder: { from: "Tirana", to: "Durrës" },
  },
  DZ: {
    name: "Algeria",
    code: "DZ",
    currency: "DZD",
    flag: "🇩🇿",
    dialCode: "+213",
    placeholder: { from: "Algiers", to: "Oran" },
  },
  AS: {
    name: "American Samoa",
    code: "AS",
    currency: "USD",
    flag: "🇦🇸",
    dialCode: "+1",
    placeholder: { from: "Pago Pago", to: "Tafuna" },
  },
  AD: {
    name: "Andorra",
    code: "AD",
    currency: "EUR",
    flag: "🇦🇩",
    dialCode: "+376",
    placeholder: { from: "Andorra la Vella", to: "Encamp" },
  },
  AO: {
    name: "Angola",
    code: "AO",
    currency: "AOA",
    flag: "🇦🇴",
    dialCode: "+244",
    placeholder: { from: "Luanda", to: "Huambo" },
  },
  AI: {
    name: "Anguilla",
    code: "AI",
    currency: "XCD",
    flag: "🇦🇮",
    dialCode: "+1",
    placeholder: { from: "The Valley", to: "Blowing Point" },
  },
  AQ: {
    name: "Antarctica",
    code: "AQ",
    currency: "USD",
    flag: "🇦🇶",
    dialCode: "+672",
    placeholder: { from: "McMurdo Station", to: "South Pole" },
  },
  AG: {
    name: "Antigua and Barbuda",
    code: "AG",
    currency: "XCD",
    flag: "🇦🇬",
    dialCode: "+1",
    placeholder: { from: "St. John's", to: "All Saints" },
  },
  AR: {
    name: "Argentina",
    code: "AR",
    currency: "ARS",
    flag: "🇦🇷",
    dialCode: "+54",
    placeholder: { from: "Buenos Aires", to: "Córdoba" },
  },
  AM: {
    name: "Armenia",
    code: "AM",
    currency: "AMD",
    flag: "🇦🇲",
    dialCode: "+374",
    placeholder: { from: "Yerevan", to: "Gyumri" },
  },
  AW: {
    name: "Aruba",
    code: "AW",
    currency: "AWG",
    flag: "🇦🇼",
    dialCode: "+297",
    placeholder: { from: "Oranjestad", to: "San Nicolaas" },
  },
  AU: {
    name: "Australia",
    code: "AU",
    currency: "AUD",
    flag: "🇦🇺",
    dialCode: "+61",
    placeholder: { from: "Sydney", to: "Melbourne" },
  },
  AT: {
    name: "Austria",
    code: "AT",
    currency: "EUR",
    flag: "🇦🇹",
    dialCode: "+43",
    placeholder: { from: "Vienna", to: "Salzburg" },
  },
  AZ: {
    name: "Azerbaijan",
    code: "AZ",
    currency: "AZN",
    flag: "🇦🇿",
    dialCode: "+994",
    placeholder: { from: "Baku", to: "Ganja" },
  },
  BS: {
    name: "Bahamas",
    code: "BS",
    currency: "BSD",
    flag: "🇧🇸",
    dialCode: "+1",
    placeholder: { from: "Nassau", to: "Freeport" },
  },
  BH: {
    name: "Bahrain",
    code: "BH",
    currency: "BHD",
    flag: "🇧🇭",
    dialCode: "+973",
    placeholder: { from: "Manama", to: "Riffa" },
  },
  BD: {
    name: "Bangladesh",
    code: "BD",
    currency: "BDT",
    flag: "🇧🇩",
    dialCode: "+880",
    placeholder: { from: "Dhaka", to: "Chittagong" },
  },
  BB: {
    name: "Barbados",
    code: "BB",
    currency: "BBD",
    flag: "🇧🇧",
    dialCode: "+1",
    placeholder: { from: "Bridgetown", to: "Speightstown" },
  },
  BY: {
    name: "Belarus",
    code: "BY",
    currency: "BYN",
    flag: "🇧🇾",
    dialCode: "+375",
    placeholder: { from: "Minsk", to: "Gomel" },
  },
  BE: {
    name: "Belgium",
    code: "BE",
    currency: "EUR",
    flag: "🇧🇪",
    dialCode: "+32",
    placeholder: { from: "Brussels", to: "Antwerp" },
  },
  BZ: {
    name: "Belize",
    code: "BZ",
    currency: "BZD",
    flag: "🇧🇿",
    dialCode: "+501",
    placeholder: { from: "Belize City", to: "Belmopan" },
  },
  BJ: {
    name: "Benin",
    code: "BJ",
    currency: "XOF",
    flag: "🇧🇯",
    dialCode: "+229",
    placeholder: { from: "Cotonou", to: "Porto-Novo" },
  },
  BM: {
    name: "Bermuda",
    code: "BM",
    currency: "BMD",
    flag: "🇧🇲",
    dialCode: "+1",
    placeholder: { from: "Hamilton", to: "St. George's" },
  },
  BT: {
    name: "Bhutan",
    code: "BT",
    currency: "BTN",
    flag: "🇧🇹",
    dialCode: "+975",
    placeholder: { from: "Thimphu", to: "Phuntsholing" },
  },
  BO: {
    name: "Bolivia",
    code: "BO",
    currency: "BOB",
    flag: "🇧🇴",
    dialCode: "+591",
    placeholder: { from: "La Paz", to: "Santa Cruz" },
  },
  BA: {
    name: "Bosnia and Herzegovina",
    code: "BA",
    currency: "BAM",
    flag: "🇧🇦",
    dialCode: "+387",
    placeholder: { from: "Sarajevo", to: "Banja Luka" },
  },
  BW: {
    name: "Botswana",
    code: "BW",
    currency: "BWP",
    flag: "🇧🇼",
    dialCode: "+267",
    placeholder: { from: "Gaborone", to: "Francistown" },
  },
  BV: {
    name: "Bouvet Island",
    code: "BV",
    currency: "NOK",
    flag: "🇧🇻",
    dialCode: "+47",
    placeholder: { from: "Bouvet Island", to: "N/A" },
  },
  BR: {
    name: "Brazil",
    code: "BR",
    currency: "BRL",
    flag: "🇧🇷",
    dialCode: "+55",
    placeholder: { from: "São Paulo", to: "Rio de Janeiro" },
  },
  IO: {
    name: "British Indian Ocean Territory",
    code: "IO",
    currency: "USD",
    flag: "🇮🇴",
    dialCode: "+246",
    placeholder: { from: "Diego Garcia", to: "N/A" },
  },
  BN: {
    name: "Brunei Darussalam",
    code: "BN",
    currency: "BND",
    flag: "🇧🇳",
    dialCode: "+673",
    placeholder: { from: "Bandar Seri Begawan", to: "Kuala Belait" },
  },
  BG: {
    name: "Bulgaria",
    code: "BG",
    currency: "BGN",
    flag: "🇧🇬",
    dialCode: "+359",
    placeholder: { from: "Sofia", to: "Plovdiv" },
  },
  BF: {
    name: "Burkina Faso",
    code: "BF",
    currency: "XOF",
    flag: "🇧🇫",
    dialCode: "+226",
    placeholder: { from: "Ouagadougou", to: "Bobo-Dioulasso" },
  },
  BI: {
    name: "Burundi",
    code: "BI",
    currency: "BIF",
    flag: "🇧🇮",
    dialCode: "+257",
    placeholder: { from: "Bujumbura", to: "Gitega" },
  },
  KH: {
    name: "Cambodia",
    code: "KH",
    currency: "KHR",
    flag: "🇰🇭",
    dialCode: "+855",
    placeholder: { from: "Phnom Penh", to: "Siem Reap" },
  },
  CM: {
    name: "Cameroon",
    code: "CM",
    currency: "XAF",
    flag: "🇨🇲",
    dialCode: "+237",
    placeholder: { from: "Douala", to: "Yaoundé" },
  },
  CA: {
    name: "Canada",
    code: "CA",
    currency: "CAD",
    flag: "🇨🇦",
    dialCode: "+1",
    placeholder: { from: "Toronto", to: "Vancouver" },
  },
  CV: {
    name: "Cape Verde",
    code: "CV",
    currency: "CVE",
    flag: "🇨🇻",
    dialCode: "+238",
    placeholder: { from: "Praia", to: "Mindelo" },
  },
  KY: {
    name: "Cayman Islands",
    code: "KY",
    currency: "KYD",
    flag: "🇰🇾",
    dialCode: "+1",
    placeholder: { from: "George Town", to: "West Bay" },
  },
  CF: {
    name: "Central African Republic",
    code: "CF",
    currency: "XAF",
    flag: "🇨🇫",
    dialCode: "+236",
    placeholder: { from: "Bangui", to: "Bimbo" },
  },
  TD: {
    name: "Chad",
    code: "TD",
    currency: "XAF",
    flag: "🇹🇩",
    dialCode: "+235",
    placeholder: { from: "N'Djamena", to: "Moundou" },
  },
  CL: {
    name: "Chile",
    code: "CL",
    currency: "CLP",
    flag: "🇨🇱",
    dialCode: "+56",
    placeholder: { from: "Santiago", to: "Valparaíso" },
  },
  CN: {
    name: "China",
    code: "CN",
    currency: "CNY",
    flag: "🇨🇳",
    dialCode: "+86",
    placeholder: { from: "Beijing", to: "Shanghai" },
  },
  CX: {
    name: "Christmas Island",
    code: "CX",
    currency: "AUD",
    flag: "🇨🇽",
    dialCode: "+61",
    placeholder: { from: "Flying Fish Cove", to: "Poon Saan" },
  },
  CC: {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    currency: "AUD",
    flag: "🇨🇨",
    dialCode: "+61",
    placeholder: { from: "West Island", to: "Bantam" },
  },
  CO: {
    name: "Colombia",
    code: "CO",
    currency: "COP",
    flag: "🇨🇴",
    dialCode: "+57",
    placeholder: { from: "Bogotá", to: "Medellín" },
  },
  KM: {
    name: "Comoros",
    code: "KM",
    currency: "KMF",
    flag: "🇰🇲",
    dialCode: "+269",
    placeholder: { from: "Moroni", to: "Mutsamudu" },
  },
  CG: {
    name: "Congo",
    code: "CG",
    currency: "XAF",
    flag: "🇨🇬",
    dialCode: "+242",
    placeholder: { from: "Brazzaville", to: "Pointe-Noire" },
  },
  CD: {
    name: "Congo (Democratic Republic)",
    code: "CD",
    currency: "CDF",
    flag: "🇨🇩",
    dialCode: "+243",
    placeholder: { from: "Kinshasa", to: "Lubumbashi" },
  },
  CK: {
    name: "Cook Islands",
    code: "CK",
    currency: "NZD",
    flag: "🇨🇰",
    dialCode: "+682",
    placeholder: { from: "Avarua", to: "Amuri" },
  },
  CR: {
    name: "Costa Rica",
    code: "CR",
    currency: "CRC",
    flag: "🇨🇷",
    dialCode: "+506",
    placeholder: { from: "San José", to: "Alajuela" },
  },
  HR: {
    name: "Croatia",
    code: "HR",
    currency: "EUR",
    flag: "🇭🇷",
    dialCode: "+385",
    placeholder: { from: "Zagreb", to: "Split" },
  },
  CU: {
    name: "Cuba",
    code: "CU",
    currency: "CUP",
    flag: "🇨🇺",
    dialCode: "+53",
    placeholder: { from: "Havana", to: "Santiago de Cuba" },
  },
  CY: {
    name: "Cyprus",
    code: "CY",
    currency: "EUR",
    flag: "🇨🇾",
    dialCode: "+357",
    placeholder: { from: "Nicosia", to: "Limassol" },
  },
  CZ: {
    name: "Czech Republic",
    code: "CZ",
    currency: "CZK",
    flag: "🇨🇿",
    dialCode: "+420",
    placeholder: { from: "Prague", to: "Brno" },
  },
  DK: {
    name: "Denmark",
    code: "DK",
    currency: "DKK",
    flag: "🇩🇰",
    dialCode: "+45",
    placeholder: { from: "Copenhagen", to: "Aarhus" },
  },
  DJ: {
    name: "Djibouti",
    code: "DJ",
    currency: "DJF",
    flag: "🇩🇯",
    dialCode: "+253",
    placeholder: { from: "Djibouti City", to: "Ali Sabieh" },
  },
  DM: {
    name: "Dominica",
    code: "DM",
    currency: "XCD",
    flag: "🇩🇲",
    dialCode: "+1",
    placeholder: { from: "Roseau", to: "Portsmouth" },
  },
  DO: {
    name: "Dominican Republic",
    code: "DO",
    currency: "DOP",
    flag: "🇩🇴",
    dialCode: "+1",
    placeholder: { from: "Santo Domingo", to: "Santiago" },
  },
  EC: {
    name: "Ecuador",
    code: "EC",
    currency: "USD",
    flag: "🇪🇨",
    dialCode: "+593",
    placeholder: { from: "Quito", to: "Guayaquil" },
  },
  EG: {
    name: "Egypt",
    code: "EG",
    currency: "EGP",
    flag: "🇪🇬",
    dialCode: "+20",
    placeholder: { from: "Cairo", to: "Alexandria" },
  },
  SV: {
    name: "El Salvador",
    code: "SV",
    currency: "USD",
    flag: "🇸🇻",
    dialCode: "+503",
    placeholder: { from: "San Salvador", to: "Santa Ana" },
  },
  GQ: {
    name: "Equatorial Guinea",
    code: "GQ",
    currency: "XAF",
    flag: "🇬🇶",
    dialCode: "+240",
    placeholder: { from: "Malabo", to: "Bata" },
  },
  ER: {
    name: "Eritrea",
    code: "ER",
    currency: "ERN",
    flag: "🇪🇷",
    dialCode: "+291",
    placeholder: { from: "Asmara", to: "Massawa" },
  },
  EE: {
    name: "Estonia",
    code: "EE",
    currency: "EUR",
    flag: "🇪🇪",
    dialCode: "+372",
    placeholder: { from: "Tallinn", to: "Tartu" },
  },
  ET: {
    name: "Ethiopia",
    code: "ET",
    currency: "ETB",
    flag: "🇪🇹",
    dialCode: "+251",
    placeholder: { from: "Addis Ababa", to: "Dire Dawa" },
  },
  FK: {
    name: "Falkland Islands",
    code: "FK",
    currency: "FKP",
    flag: "🇫🇰",
    dialCode: "+500",
    placeholder: { from: "Stanley", to: "Goose Green" },
  },
  FO: {
    name: "Faroe Islands",
    code: "FO",
    currency: "DKK",
    flag: "🇫🇴",
    dialCode: "+298",
    placeholder: { from: "Tórshavn", to: "Klaksvík" },
  },
  FJ: {
    name: "Fiji",
    code: "FJ",
    currency: "FJD",
    flag: "🇫🇯",
    dialCode: "+679",
    placeholder: { from: "Suva", to: "Nadi" },
  },
  FI: {
    name: "Finland",
    code: "FI",
    currency: "EUR",
    flag: "🇫🇮",
    dialCode: "+358",
    placeholder: { from: "Helsinki", to: "Espoo" },
  },
  FR: {
    name: "France",
    code: "FR",
    currency: "EUR",
    flag: "🇫🇷",
    dialCode: "+33",
    placeholder: { from: "Paris", to: "Marseille" },
  },
  GF: {
    name: "French Guiana",
    code: "GF",
    currency: "EUR",
    flag: "🇬🇫",
    dialCode: "+594",
    placeholder: { from: "Cayenne", to: "Saint-Laurent" },
  },
  PF: {
    name: "French Polynesia",
    code: "PF",
    currency: "XPF",
    flag: "🇵🇫",
    dialCode: "+689",
    placeholder: { from: "Papeete", to: "Faaa" },
  },
  GA: {
    name: "Gabon",
    code: "GA",
    currency: "XAF",
    flag: "🇬🇦",
    dialCode: "+241",
    placeholder: { from: "Libreville", to: "Port-Gentil" },
  },
  GM: {
    name: "Gambia",
    code: "GM",
    currency: "GMD",
    flag: "🇬🇲",
    dialCode: "+220",
    placeholder: { from: "Banjul", to: "Serekunda" },
  },
  GE: {
    name: "Georgia",
    code: "GE",
    currency: "GEL",
    flag: "🇬🇪",
    dialCode: "+995",
    placeholder: { from: "Tbilisi", to: "Batumi" },
  },
  DE: {
    name: "Germany",
    code: "DE",
    currency: "EUR",
    flag: "🇩🇪",
    dialCode: "+49",
    placeholder: { from: "Berlin", to: "Munich" },
  },
  GH: {
    name: "Ghana",
    code: "GH",
    currency: "GHS",
    flag: "🇬🇭",
    dialCode: "+233",
    placeholder: { from: "Accra", to: "Kumasi" },
  },
  GI: {
    name: "Gibraltar",
    code: "GI",
    currency: "GIP",
    flag: "🇬🇮",
    dialCode: "+350",
    placeholder: { from: "Gibraltar", to: "N/A" },
  },
  GR: {
    name: "Greece",
    code: "GR",
    currency: "EUR",
    flag: "🇬🇷",
    dialCode: "+30",
    placeholder: { from: "Athens", to: "Thessaloniki" },
  },
  GL: {
    name: "Greenland",
    code: "GL",
    currency: "DKK",
    flag: "🇬🇱",
    dialCode: "+299",
    placeholder: { from: "Nuuk", to: "Sisimiut" },
  },
  GD: {
    name: "Grenada",
    code: "GD",
    currency: "XCD",
    flag: "🇬🇩",
    dialCode: "+1",
    placeholder: { from: "St. George's", to: "Gouyave" },
  },
  GP: {
    name: "Guadeloupe",
    code: "GP",
    currency: "EUR",
    flag: "🇬🇵",
    dialCode: "+590",
    placeholder: { from: "Basse-Terre", to: "Pointe-à-Pitre" },
  },
  GU: {
    name: "Guam",
    code: "GU",
    currency: "USD",
    flag: "🇬🇺",
    dialCode: "+1",
    placeholder: { from: "Hagåtña", to: "Dededo" },
  },
  GT: {
    name: "Guatemala",
    code: "GT",
    currency: "GTQ",
    flag: "🇬🇹",
    dialCode: "+502",
    placeholder: { from: "Guatemala City", to: "Quetzaltenango" },
  },
  GG: {
    name: "Guernsey",
    code: "GG",
    currency: "GBP",
    flag: "🇬🇬",
    dialCode: "+44",
    placeholder: { from: "St. Peter Port", to: "Vale" },
  },
  GN: {
    name: "Guinea",
    code: "GN",
    currency: "GNF",
    flag: "🇬🇳",
    dialCode: "+224",
    placeholder: { from: "Conakry", to: "Nzérékoré" },
  },
  GW: {
    name: "Guinea-Bissau",
    code: "GW",
    currency: "XOF",
    flag: "🇬🇼",
    dialCode: "+245",
    placeholder: { from: "Bissau", to: "Gabú" },
  },
  GY: {
    name: "Guyana",
    code: "GY",
    currency: "GYD",
    flag: "🇬🇾",
    dialCode: "+592",
    placeholder: { from: "Georgetown", to: "Linden" },
  },
  HT: {
    name: "Haiti",
    code: "HT",
    currency: "HTG",
    flag: "🇭🇹",
    dialCode: "+509",
    placeholder: { from: "Port-au-Prince", to: "Gonaïves" },
  },
  HN: {
    name: "Honduras",
    code: "HN",
    currency: "HNL",
    flag: "🇭🇳",
    dialCode: "+504",
    placeholder: { from: "Tegucigalpa", to: "San Pedro Sula" },
  },
  HK: {
    name: "Hong Kong",
    code: "HK",
    currency: "HKD",
    flag: "🇭🇰",
    dialCode: "+852",
    placeholder: { from: "Hong Kong", to: "Kowloon" },
  },
  HU: {
    name: "Hungary",
    code: "HU",
    currency: "HUF",
    flag: "🇭🇺",
    dialCode: "+36",
    placeholder: { from: "Budapest", to: "Debrecen" },
  },
  IS: {
    name: "Iceland",
    code: "IS",
    currency: "ISK",
    flag: "🇮🇸",
    dialCode: "+354",
    placeholder: { from: "Reykjavík", to: "Akureyri" },
  },
  IN: {
    name: "India",
    code: "IN",
    currency: "INR",
    flag: "🇮🇳",
    dialCode: "+91",
    placeholder: { from: "New Delhi", to: "Mumbai" },
  },
  ID: {
    name: "Indonesia",
    code: "ID",
    currency: "IDR",
    flag: "🇮🇩",
    dialCode: "+62",
    placeholder: { from: "Jakarta", to: "Surabaya" },
  },
  IR: {
    name: "Iran",
    code: "IR",
    currency: "IRR",
    flag: "🇮🇷",
    dialCode: "+98",
    placeholder: { from: "Tehran", to: "Mashhad" },
  },
  IQ: {
    name: "Iraq",
    code: "IQ",
    currency: "IQD",
    flag: "🇮🇶",
    dialCode: "+964",
    placeholder: { from: "Baghdad", to: "Basra" },
  },
  IE: {
    name: "Ireland",
    code: "IE",
    currency: "EUR",
    flag: "🇮🇪",
    dialCode: "+353",
    placeholder: { from: "Dublin", to: "Cork" },
  },
  IM: {
    name: "Isle of Man",
    code: "IM",
    currency: "GBP",
    flag: "🇮🇲",
    dialCode: "+44",
    placeholder: { from: "Douglas", to: "Ramsey" },
  },
  IT: {
    name: "Italy",
    code: "IT",
    currency: "EUR",
    flag: "🇮🇹",
    dialCode: "+39",
    placeholder: { from: "Rome", to: "Milan" },
  },
  JM: {
    name: "Jamaica",
    code: "JM",
    currency: "JMD",
    flag: "🇯🇲",
    dialCode: "+1",
    placeholder: { from: "Kingston", to: "Montego Bay" },
  },
  JP: {
    name: "Japan",
    code: "JP",
    currency: "JPY",
    flag: "🇯🇵",
    dialCode: "+81",
    placeholder: { from: "Tokyo", to: "Osaka" },
  },
  JE: {
    name: "Jersey",
    code: "JE",
    currency: "GBP",
    flag: "🇯🇪",
    dialCode: "+44",
    placeholder: { from: "St. Helier", to: "Gorey" },
  },
  JO: {
    name: "Jordan",
    code: "JO",
    currency: "JOD",
    flag: "🇯🇴",
    dialCode: "+962",
    placeholder: { from: "Amman", to: "Zarqa" },
  },
  KZ: {
    name: "Kazakhstan",
    code: "KZ",
    currency: "KZT",
    flag: "🇰🇿",
    dialCode: "+7",
    placeholder: { from: "Astana", to: "Almaty" },
  },
  KE: {
    name: "Kenya",
    code: "KE",
    currency: "KES",
    flag: "🇰🇪",
    dialCode: "+254",
    placeholder: { from: "Nairobi", to: "Mombasa" },
  },
  KI: {
    name: "Kiribati",
    code: "KI",
    currency: "AUD",
    flag: "🇰🇮",
    dialCode: "+686",
    placeholder: { from: "Tarawa", to: "Betio" },
  },
  KW: {
    name: "Kuwait",
    code: "KW",
    currency: "KWD",
    flag: "🇰🇼",
    dialCode: "+965",
    placeholder: { from: "Kuwait City", to: "Al Jahra" },
  },
  KG: {
    name: "Kyrgyzstan",
    code: "KG",
    currency: "KGS",
    flag: "🇰🇬",
    dialCode: "+996",
    placeholder: { from: "Bishkek", to: "Osh" },
  },
  LA: {
    name: "Laos",
    code: "LA",
    currency: "LAK",
    flag: "🇱🇦",
    dialCode: "+856",
    placeholder: { from: "Vientiane", to: "Pakse" },
  },
  LV: {
    name: "Latvia",
    code: "LV",
    currency: "EUR",
    flag: "🇱🇻",
    dialCode: "+371",
    placeholder: { from: "Riga", to: "Daugavpils" },
  },
  LB: {
    name: "Lebanon",
    code: "LB",
    currency: "LBP",
    flag: "🇱🇧",
    dialCode: "+961",
    placeholder: { from: "Beirut", to: "Tripoli" },
  },
  LS: {
    name: "Lesotho",
    code: "LS",
    currency: "LSL",
    flag: "🇱🇸",
    dialCode: "+266",
    placeholder: { from: "Maseru", to: "Teyateyaneng" },
  },
  LR: {
    name: "Liberia",
    code: "LR",
    currency: "LRD",
    flag: "🇱🇷",
    dialCode: "+231",
    placeholder: { from: "Monrovia", to: "Gbarnga" },
  },
  LY: {
    name: "Libya",
    code: "LY",
    currency: "LYD",
    flag: "🇱🇾",
    dialCode: "+218",
    placeholder: { from: "Tripoli", to: "Benghazi" },
  },
  LI: {
    name: "Liechtenstein",
    code: "LI",
    currency: "CHF",
    flag: "🇱🇮",
    dialCode: "+423",
    placeholder: { from: "Vaduz", to: "Schaan" },
  },
  LT: {
    name: "Lithuania",
    code: "LT",
    currency: "EUR",
    flag: "🇱🇹",
    dialCode: "+370",
    placeholder: { from: "Vilnius", to: "Kaunas" },
  },
  LU: {
    name: "Luxembourg",
    code: "LU",
    currency: "EUR",
    flag: "🇱🇺",
    dialCode: "+352",
    placeholder: { from: "Luxembourg City", to: "Esch-sur-Alzette" },
  },
  MO: {
    name: "Macau",
    code: "MO",
    currency: "MOP",
    flag: "🇲🇴",
    dialCode: "+853",
    placeholder: { from: "Macau", to: "Taipa" },
  },
  MG: {
    name: "Madagascar",
    code: "MG",
    currency: "MGA",
    flag: "🇲🇬",
    dialCode: "+261",
    placeholder: { from: "Antananarivo", to: "Toamasina" },
  },
  MW: {
    name: "Malawi",
    code: "MW",
    currency: "MWK",
    flag: "🇲🇼",
    dialCode: "+265",
    placeholder: { from: "Lilongwe", to: "Blantyre" },
  },
  MY: {
    name: "Malaysia",
    code: "MY",
    currency: "MYR",
    flag: "🇲🇾",
    dialCode: "+60",
    placeholder: { from: "Kuala Lumpur", to: "Penang" },
  },
  MV: {
    name: "Maldives",
    code: "MV",
    currency: "MVR",
    flag: "🇲🇻",
    dialCode: "+960",
    placeholder: { from: "Malé", to: "Addu City" },
  },
  ML: {
    name: "Mali",
    code: "ML",
    currency: "XOF",
    flag: "🇲🇱",
    dialCode: "+223",
    placeholder: { from: "Bamako", to: "Sikasso" },
  },
  MT: {
    name: "Malta",
    code: "MT",
    currency: "EUR",
    flag: "🇲🇹",
    dialCode: "+356",
    placeholder: { from: "Valletta", to: "Birkirkara" },
  },
  MH: {
    name: "Marshall Islands",
    code: "MH",
    currency: "USD",
    flag: "🇲🇭",
    dialCode: "+692",
    placeholder: { from: "Majuro", to: "Ebeye" },
  },
  MQ: {
    name: "Martinique",
    code: "MQ",
    currency: "EUR",
    flag: "🇲🇶",
    dialCode: "+596",
    placeholder: { from: "Fort-de-France", to: "Le Lamentin" },
  },
  MR: {
    name: "Mauritania",
    code: "MR",
    currency: "MRU",
    flag: "🇲🇷",
    dialCode: "+222",
    placeholder: { from: "Nouakchott", to: "Nouadhibou" },
  },
  MU: {
    name: "Mauritius",
    code: "MU",
    currency: "MUR",
    flag: "🇲🇺",
    dialCode: "+230",
    placeholder: { from: "Port Louis", to: "Beau Bassin" },
  },
  YT: {
    name: "Mayotte",
    code: "YT",
    currency: "EUR",
    flag: "🇾🇹",
    dialCode: "+262",
    placeholder: { from: "Mamoudzou", to: "Dzaoudzi" },
  },
  MX: {
    name: "Mexico",
    code: "MX",
    currency: "MXN",
    flag: "🇲🇽",
    dialCode: "+52",
    placeholder: { from: "Mexico City", to: "Cancún" },
  },
  FM: {
    name: "Micronesia",
    code: "FM",
    currency: "USD",
    flag: "🇫🇲",
    dialCode: "+691",
    placeholder: { from: "Palikir", to: "Weno" },
  },
  MD: {
    name: "Moldova",
    code: "MD",
    currency: "MDL",
    flag: "🇲🇩",
    dialCode: "+373",
    placeholder: { from: "Chisinau", to: "Tiraspol" },
  },
  MC: {
    name: "Monaco",
    code: "MC",
    currency: "EUR",
    flag: "🇲🇨",
    dialCode: "+377",
    placeholder: { from: "Monaco", to: "Monte Carlo" },
  },
  MN: {
    name: "Mongolia",
    code: "MN",
    currency: "MNT",
    flag: "🇲🇳",
    dialCode: "+976",
    placeholder: { from: "Ulaanbaatar", to: "Erdenet" },
  },
  ME: {
    name: "Montenegro",
    code: "ME",
    currency: "EUR",
    flag: "🇲🇪",
    dialCode: "+382",
    placeholder: { from: "Podgorica", to: "Nikšić" },
  },
  MS: {
    name: "Montserrat",
    code: "MS",
    currency: "XCD",
    flag: "🇲🇸",
    dialCode: "+1",
    placeholder: { from: "Plymouth", to: "Brades" },
  },
  MA: {
    name: "Morocco",
    code: "MA",
    currency: "MAD",
    flag: "🇲🇦",
    dialCode: "+212",
    placeholder: { from: "Rabat", to: "Casablanca" },
  },
  MZ: {
    name: "Mozambique",
    code: "MZ",
    currency: "MZN",
    flag: "🇲🇿",
    dialCode: "+258",
    placeholder: { from: "Maputo", to: "Beira" },
  },
  MM: {
    name: "Myanmar",
    code: "MM",
    currency: "MMK",
    flag: "🇲🇲",
    dialCode: "+95",
    placeholder: { from: "Naypyidaw", to: "Yangon" },
  },
  NA: {
    name: "Namibia",
    code: "NA",
    currency: "NAD",
    flag: "🇳🇦",
    dialCode: "+264",
    placeholder: { from: "Windhoek", to: "Walvis Bay" },
  },
  NR: {
    name: "Nauru",
    code: "NR",
    currency: "AUD",
    flag: "🇳🇷",
    dialCode: "+674",
    placeholder: { from: "Yaren", to: "Denigomodu" },
  },
  NP: {
    name: "Nepal",
    code: "NP",
    currency: "NPR",
    flag: "🇳🇵",
    dialCode: "+977",
    placeholder: { from: "Kathmandu", to: "Pokhara" },
  },
  NL: {
    name: "Netherlands",
    code: "NL",
    currency: "EUR",
    flag: "🇳🇱",
    dialCode: "+31",
    placeholder: { from: "Amsterdam", to: "Rotterdam" },
  },
  NC: {
    name: "New Caledonia",
    code: "NC",
    currency: "XPF",
    flag: "🇳🇨",
    dialCode: "+687",
    placeholder: { from: "Nouméa", to: "Mont-Dore" },
  },
  NZ: {
    name: "New Zealand",
    code: "NZ",
    currency: "NZD",
    flag: "🇳🇿",
    dialCode: "+64",
    placeholder: { from: "Auckland", to: "Wellington" },
  },
  NI: {
    name: "Nicaragua",
    code: "NI",
    currency: "NIO",
    flag: "🇳🇮",
    dialCode: "+505",
    placeholder: { from: "Managua", to: "León" },
  },
  NE: {
    name: "Niger",
    code: "NE",
    currency: "XOF",
    flag: "🇳🇪",
    dialCode: "+227",
    placeholder: { from: "Niamey", to: "Zinder" },
  },
  NG: {
    name: "Nigeria",
    code: "NG",
    currency: "NGN",
    flag: "🇳🇬",
    dialCode: "+234",
    placeholder: { from: "Lagos", to: "Abuja" },
  },
  NU: {
    name: "Niue",
    code: "NU",
    currency: "NZD",
    flag: "🇳🇺",
    dialCode: "+683",
    placeholder: { from: "Alofi", to: "Hakupu" },
  },
  NF: {
    name: "Norfolk Island",
    code: "NF",
    currency: "AUD",
    flag: "🇳🇫",
    dialCode: "+672",
    placeholder: { from: "Kingston", to: "Burnt Pine" },
  },
  KP: {
    name: "North Korea",
    code: "KP",
    currency: "KPW",
    flag: "🇰🇵",
    dialCode: "+850",
    placeholder: { from: "Pyongyang", to: "Hamhung" },
  },
  MK: {
    name: "North Macedonia",
    code: "MK",
    currency: "MKD",
    flag: "🇲🇰",
    dialCode: "+389",
    placeholder: { from: "Skopje", to: "Bitola" },
  },
  MP: {
    name: "Northern Mariana Islands",
    code: "MP",
    currency: "USD",
    flag: "🇲🇵",
    dialCode: "+1",
    placeholder: { from: "Saipan", to: "Tinian" },
  },
  NO: {
    name: "Norway",
    code: "NO",
    currency: "NOK",
    flag: "🇳🇴",
    dialCode: "+47",
    placeholder: { from: "Oslo", to: "Bergen" },
  },
  OM: {
    name: "Oman",
    code: "OM",
    currency: "OMR",
    flag: "🇴🇲",
    dialCode: "+968",
    placeholder: { from: "Muscat", to: "Salalah" },
  },
  PK: {
    name: "Pakistan",
    code: "PK",
    currency: "PKR",
    flag: "🇵🇰",
    dialCode: "+92",
    placeholder: { from: "Lahore", to: "Islamabad" },
  },
  PW: {
    name: "Palau",
    code: "PW",
    currency: "USD",
    flag: "🇵🇼",
    dialCode: "+680",
    placeholder: { from: "Ngerulmud", to: "Koror" },
  },
  PS: {
    name: "Palestine",
    code: "PS",
    currency: "ILS",
    flag: "🇵🇸",
    dialCode: "+970",
    placeholder: { from: "Jerusalem", to: "Gaza City" },
  },
  PA: {
    name: "Panama",
    code: "PA",
    currency: "PAB",
    flag: "🇵🇦",
    dialCode: "+507",
    placeholder: { from: "Panama City", to: "Colón" },
  },
  PG: {
    name: "Papua New Guinea",
    code: "PG",
    currency: "PGK",
    flag: "🇵🇬",
    dialCode: "+675",
    placeholder: { from: "Port Moresby", to: "Lae" },
  },
  PY: {
    name: "Paraguay",
    code: "PY",
    currency: "PYG",
    flag: "🇵🇾",
    dialCode: "+595",
    placeholder: { from: "Asunción", to: "Ciudad del Este" },
  },
  PE: {
    name: "Peru",
    code: "PE",
    currency: "PEN",
    flag: "🇵🇪",
    dialCode: "+51",
    placeholder: { from: "Lima", to: "Cusco" },
  },
  PH: {
    name: "Philippines",
    code: "PH",
    currency: "PHP",
    flag: "🇵🇭",
    dialCode: "+63",
    placeholder: { from: "Manila", to: "Cebu City" },
  },
  PN: {
    name: "Pitcairn",
    code: "PN",
    currency: "NZD",
    flag: "🇵🇳",
    dialCode: "+64",
    placeholder: { from: "Adamstown", to: "N/A" },
  },
  PL: {
    name: "Poland",
    code: "PL",
    currency: "PLN",
    flag: "🇵🇱",
    dialCode: "+48",
    placeholder: { from: "Warsaw", to: "Kraków" },
  },
  PT: {
    name: "Portugal",
    code: "PT",
    currency: "EUR",
    flag: "🇵🇹",
    dialCode: "+351",
    placeholder: { from: "Lisbon", to: "Porto" },
  },
  PR: {
    name: "Puerto Rico",
    code: "PR",
    currency: "USD",
    flag: "🇵🇷",
    dialCode: "+1",
    placeholder: { from: "San Juan", to: "Ponce" },
  },
  QA: {
    name: "Qatar",
    code: "QA",
    currency: "QAR",
    flag: "🇶🇦",
    dialCode: "+974",
    placeholder: { from: "Doha", to: "Al Wakrah" },
  },
  RE: {
    name: "Réunion Island",
    code: "RE",
    currency: "EUR",
    flag: "🇷🇪",
    dialCode: "+262",
    placeholder: { from: "Saint-Denis", to: "Saint-Paul" },
  },
  RO: {
    name: "Romania",
    code: "RO",
    currency: "RON",
    flag: "🇷🇴",
    dialCode: "+40",
    placeholder: { from: "Bucharest", to: "Cluj-Napoca" },
  },
  RU: {
    name: "Russia",
    code: "RU",
    currency: "RUB",
    flag: "🇷🇺",
    dialCode: "+7",
    placeholder: { from: "Moscow", to: "Saint Petersburg" },
  },
  RW: {
    name: "Rwanda",
    code: "RW",
    currency: "RWF",
    flag: "🇷🇼",
    dialCode: "+250",
    placeholder: { from: "Kigali", to: "Butare" },
  },
  BL: {
    name: "Saint Barthélemy",
    code: "BL",
    currency: "EUR",
    flag: "🇧🇱",
    dialCode: "+590",
    placeholder: { from: "Gustavia", to: "Saint-Jean" },
  },
  SH: {
    name: "Saint Helena",
    code: "SH",
    currency: "SHP",
    flag: "🇸🇭",
    dialCode: "+290",
    placeholder: { from: "Jamestown", to: "Half Tree Hollow" },
  },
  KN: {
    name: "Saint Kitts and Nevis",
    code: "KN",
    currency: "XCD",
    flag: "🇰🇳",
    dialCode: "+1",
    placeholder: { from: "Basseterre", to: "Charlestown" },
  },
  LC: {
    name: "Saint Lucia",
    code: "LC",
    currency: "XCD",
    flag: "🇱🇨",
    dialCode: "+1",
    placeholder: { from: "Castries", to: "Gros Islet" },
  },
  MF: {
    name: "Saint Martin",
    code: "MF",
    currency: "EUR",
    flag: "🇲🇫",
    dialCode: "+590",
    placeholder: { from: "Marigot", to: "Grand Case" },
  },
  PM: {
    name: "Saint Pierre and Miquelon",
    code: "PM",
    currency: "EUR",
    flag: "🇵🇲",
    dialCode: "+508",
    placeholder: { from: "Saint-Pierre", to: "Miquelon" },
  },
  VC: {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    currency: "XCD",
    flag: "🇻🇨",
    dialCode: "+1",
    placeholder: { from: "Kingstown", to: "Georgetown" },
  },
  WS: {
    name: "Samoa",
    code: "WS",
    currency: "WST",
    flag: "🇼🇸",
    dialCode: "+685",
    placeholder: { from: "Apia", to: "Vaitele" },
  },
  SM: {
    name: "San Marino",
    code: "SM",
    currency: "EUR",
    flag: "🇸🇲",
    dialCode: "+378",
    placeholder: { from: "San Marino", to: "Dogana" },
  },
  ST: {
    name: "Sao Tome and Principe",
    code: "ST",
    currency: "STN",
    flag: "🇸🇹",
    dialCode: "+239",
    placeholder: { from: "São Tomé", to: "Trindade" },
  },
  SA: {
    name: "Saudi Arabia",
    code: "SA",
    currency: "SAR",
    flag: "🇸🇦",
    dialCode: "+966",
    placeholder: { from: "Riyadh", to: "Jeddah" },
  },
  SN: {
    name: "Senegal",
    code: "SN",
    currency: "XOF",
    flag: "🇸🇳",
    dialCode: "+221",
    placeholder: { from: "Dakar", to: "Touba" },
  },
  RS: {
    name: "Serbia",
    code: "RS",
    currency: "RSD",
    flag: "🇷🇸",
    dialCode: "+381",
    placeholder: { from: "Belgrade", to: "Novi Sad" },
  },
  SC: {
    name: "Seychelles",
    code: "SC",
    currency: "SCR",
    flag: "🇸🇨",
    dialCode: "+248",
    placeholder: { from: "Victoria", to: "Anse Royale" },
  },
  SL: {
    name: "Sierra Leone",
    code: "SL",
    currency: "SLL",
    flag: "🇸🇱",
    dialCode: "+232",
    placeholder: { from: "Freetown", to: "Bo" },
  },
  SG: {
    name: "Singapore",
    code: "SG",
    currency: "SGD",
    flag: "🇸🇬",
    dialCode: "+65",
    placeholder: { from: "Singapore", to: "Singapore" },
  },
  SK: {
    name: "Slovakia",
    code: "SK",
    currency: "EUR",
    flag: "🇸🇰",
    dialCode: "+421",
    placeholder: { from: "Bratislava", to: "Košice" },
  },
  SI: {
    name: "Slovenia",
    code: "SI",
    currency: "EUR",
    flag: "🇸🇮",
    dialCode: "+386",
    placeholder: { from: "Ljubljana", to: "Maribor" },
  },
  SB: {
    name: "Solomon Islands",
    code: "SB",
    currency: "SBD",
    flag: "🇸🇧",
    dialCode: "+677",
    placeholder: { from: "Honiara", to: "Gizo" },
  },
  SO: {
    name: "Somalia",
    code: "SO",
    currency: "SOS",
    flag: "🇸🇴",
    dialCode: "+252",
    placeholder: { from: "Mogadishu", to: "Hargeisa" },
  },
  ZA: {
    name: "South Africa",
    code: "ZA",
    currency: "ZAR",
    flag: "🇿🇦",
    dialCode: "+27",
    placeholder: { from: "Johannesburg", to: "Cape Town" },
  },
  KR: {
    name: "South Korea",
    code: "KR",
    currency: "KRW",
    flag: "🇰🇷",
    dialCode: "+82",
    placeholder: { from: "Seoul", to: "Busan" },
  },
  SS: {
    name: "South Sudan",
    code: "SS",
    currency: "SSP",
    flag: "🇸🇸",
    dialCode: "+211",
    placeholder: { from: "Juba", to: "Malakal" },
  },
  ES: {
    name: "Spain",
    code: "ES",
    currency: "EUR",
    flag: "🇪🇸",
    dialCode: "+34",
    placeholder: { from: "Madrid", to: "Barcelona" },
  },
  LK: {
    name: "Sri Lanka",
    code: "LK",
    currency: "LKR",
    flag: "🇱🇰",
    dialCode: "+94",
    placeholder: { from: "Colombo", to: "Kandy" },
  },
  SD: {
    name: "Sudan",
    code: "SD",
    currency: "SDG",
    flag: "🇸🇩",
    dialCode: "+249",
    placeholder: { from: "Khartoum", to: "Omdurman" },
  },
  SR: {
    name: "Suriname",
    code: "SR",
    currency: "SRD",
    flag: "🇸🇷",
    dialCode: "+597",
    placeholder: { from: "Paramaribo", to: "Lelydorp" },
  },
  SE: {
    name: "Sweden",
    code: "SE",
    currency: "SEK",
    flag: "🇸🇪",
    dialCode: "+46",
    placeholder: { from: "Stockholm", to: "Gothenburg" },
  },
  CH: {
    name: "Switzerland",
    code: "CH",
    currency: "CHF",
    flag: "🇨🇭",
    dialCode: "+41",
    placeholder: { from: "Zurich", to: "Geneva" },
  },
  SY: {
    name: "Syria",
    code: "SY",
    currency: "SYP",
    flag: "🇸🇾",
    dialCode: "+963",
    placeholder: { from: "Damascus", to: "Aleppo" },
  },
  TW: {
    name: "Taiwan",
    code: "TW",
    currency: "TWD",
    flag: "🇹🇼",
    dialCode: "+886",
    placeholder: { from: "Taipei", to: "Kaohsiung" },
  },
  TJ: {
    name: "Tajikistan",
    code: "TJ",
    currency: "TJS",
    flag: "🇹🇯",
    dialCode: "+992",
    placeholder: { from: "Dushanbe", to: "Khujand" },
  },
  TZ: {
    name: "Tanzania",
    code: "TZ",
    currency: "TZS",
    flag: "🇹🇿",
    dialCode: "+255",
    placeholder: { from: "Dodoma", to: "Dar es Salaam" },
  },
  TH: {
    name: "Thailand",
    code: "TH",
    currency: "THB",
    flag: "🇹🇭",
    dialCode: "+66",
    placeholder: { from: "Bangkok", to: "Chiang Mai" },
  },
  TL: {
    name: "Timor-Leste",
    code: "TL",
    currency: "USD",
    flag: "🇹🇱",
    dialCode: "+670",
    placeholder: { from: "Dili", to: "Baucau" },
  },
  TG: {
    name: "Togo",
    code: "TG",
    currency: "XOF",
    flag: "🇹🇬",
    dialCode: "+228",
    placeholder: { from: "Lomé", to: "Sokodé" },
  },
  TK: {
    name: "Tokelau",
    code: "TK",
    currency: "NZD",
    flag: "🇹🇰",
    dialCode: "+690",
    placeholder: { from: "Fakaofo", to: "Atafu" },
  },
  TO: {
    name: "Tonga",
    code: "TO",
    currency: "TOP",
    flag: "🇹🇴",
    dialCode: "+676",
    placeholder: { from: "Nuku'alofa", to: "Neiafu" },
  },
  TT: {
    name: "Trinidad and Tobago",
    code: "TT",
    currency: "TTD",
    flag: "🇹🇹",
    dialCode: "+1",
    placeholder: { from: "Port of Spain", to: "Chaguanas" },
  },
  TN: {
    name: "Tunisia",
    code: "TN",
    currency: "TND",
    flag: "🇹🇳",
    dialCode: "+216",
    placeholder: { from: "Tunis", to: "Sfax" },
  },
  TR: {
    name: "Turkey",
    code: "TR",
    currency: "TRY",
    flag: "🇹🇷",
    dialCode: "+90",
    placeholder: { from: "Istanbul", to: "Ankara" },
  },
  TM: {
    name: "Turkmenistan",
    code: "TM",
    currency: "TMT",
    flag: "🇹🇲",
    dialCode: "+993",
    placeholder: { from: "Ashgabat", to: "Türkmenabat" },
  },
  TV: {
    name: "Tuvalu",
    code: "TV",
    currency: "AUD",
    flag: "🇹🇻",
    dialCode: "+688",
    placeholder: { from: "Funafuti", to: "Vaitupu" },
  },
  UG: {
    name: "Uganda",
    code: "UG",
    currency: "UGX",
    flag: "🇺🇬",
    dialCode: "+256",
    placeholder: { from: "Kampala", to: "Entebbe" },
  },
  UA: {
    name: "Ukraine",
    code: "UA",
    currency: "UAH",
    flag: "🇺🇦",
    dialCode: "+380",
    placeholder: { from: "Kyiv", to: "Lviv" },
  },
  AE: {
    name: "United Arab Emirates",
    code: "AE",
    currency: "AED",
    flag: "🇦🇪",
    dialCode: "+971",
    placeholder: { from: "Dubai", to: "Abu Dhabi" },
  },
  GB: {
    name: "United Kingdom",
    code: "GB",
    currency: "GBP",
    flag: "🇬🇧",
    dialCode: "+44",
    placeholder: { from: "London", to: "Manchester" },
  },
  US: {
    name: "United States",
    code: "US",
    currency: "USD",
    flag: "🇺🇸",
    dialCode: "+1",
    placeholder: { from: "New York", to: "Los Angeles" },
  },
  UY: {
    name: "Uruguay",
    code: "UY",
    currency: "UYU",
    flag: "🇺🇾",
    dialCode: "+598",
    placeholder: { from: "Montevideo", to: "Salto" },
  },
  UZ: {
    name: "Uzbekistan",
    code: "UZ",
    currency: "UZS",
    flag: "🇺🇿",
    dialCode: "+998",
    placeholder: { from: "Tashkent", to: "Samarkand" },
  },
  VU: {
    name: "Vanuatu",
    code: "VU",
    currency: "VUV",
    flag: "🇻🇺",
    dialCode: "+678",
    placeholder: { from: "Port Vila", to: "Luganville" },
  },
  VA: {
    name: "Vatican City",
    code: "VA",
    currency: "EUR",
    flag: "🇻🇦",
    dialCode: "+39",
    placeholder: { from: "Vatican City", to: "N/A" },
  },
  VE: {
    name: "Venezuela",
    code: "VE",
    currency: "VES",
    flag: "🇻🇪",
    dialCode: "+58",
    placeholder: { from: "Caracas", to: "Maracaibo" },
  },
  VN: {
    name: "Vietnam",
    code: "VN",
    currency: "VND",
    flag: "🇻🇳",
    dialCode: "+84",
    placeholder: { from: "Hanoi", to: "Ho Chi Minh City" },
  },
  WF: {
    name: "Wallis and Futuna",
    code: "WF",
    currency: "XPF",
    flag: "🇼🇫",
    dialCode: "+681",
    placeholder: { from: "Mata-Utu", to: "Leava" },
  },
  EH: {
    name: "Western Sahara",
    code: "EH",
    currency: "MAD",
    flag: "🇪🇭",
    dialCode: "+212",
    placeholder: { from: "Laayoune", to: "Dakhla" },
  },
  YE: {
    name: "Yemen",
    code: "YE",
    currency: "YER",
    flag: "🇾🇪",
    dialCode: "+967",
    placeholder: { from: "Sana'a", to: "Aden" },
  },
  ZM: {
    name: "Zambia",
    code: "ZM",
    currency: "ZMW",
    flag: "🇿🇲",
    dialCode: "+260",
    placeholder: { from: "Lusaka", to: "Kitwe" },
  },
  ZW: {
    name: "Zimbabwe",
    code: "ZW",
    currency: "ZWL",
    flag: "🇿🇼",
    dialCode: "+263",
    placeholder: { from: "Harare", to: "Bulawayo" },
  },
};

/** For selects: label = country name, value = ISO 3166-1 alpha-2 (uppercase). */
export const COUNTRIES_FOR_SELECT: Country[] = Object.values(countriesData)
  .map((c) => ({ name: c.name, code: c.code.toUpperCase() }))
  .sort((a, b) => a.name.localeCompare(b.name));
